import React from "react";
import { Box, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicTextareaWithLabel = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Textarea with label & helperText"}
        language={"js"}
        value={
          "         <TextField\n" +
          '          label="Label Text"\n' +
          "          multiline\n" +
          "          minRows={3}\n" +
          "          maxRows={4}\n" +
          "        />\n" +
          "\n" +
          "        <TextField\n" +
          '          label="Label Text"\n' +
          "          multiline\n" +
          "          minRows={3}\n" +
          "          maxRows={4}\n" +
          '          helperText="Helper text"\n' +
          "        />"
        }
      >
        <TextField label="Label Text" multiline minRows={3} maxRows={4} />

        <TextField
          label="Label Text"
          multiline
          minRows={3}
          maxRows={4}
          helperText="Helper text"
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicTextareaWithLabel;
